import { reviewers as urlLayer } from '@/api/url_layer';
import { capitalizeText, getId } from '@/helpers';

export const reviewers = {
  namespaced: true,
  state: {
    reviewers: {
      synchrotron: [],
      cryoem: [],
    },
  },
  mutations: {
    setReviewers(state, { newReviewers, infrastructure }) {
      state.reviewers[infrastructure] = newReviewers;
    },
  },
  actions: {
    async loadReviewers({ commit }, infrastructure) {
      const [standardReviewers, rapidAccessReviewers] = await Promise.all([
        urlLayer[`loadReviewers${capitalizeText(infrastructure)}`](),
        infrastructure === 'synchrotron' ? urlLayer[`loadReviewersRapidAccess${capitalizeText(infrastructure)}`]() : [],
      ]);
      const response = [...(standardReviewers?.data || []), ...(rapidAccessReviewers.data || [])];
      commit('setReviewers', { newReviewers: response, infrastructure });
    },
  },
  getters: {
    reviewerById: (state) => (reviewerId, infrastructure) => state.reviewers[infrastructure].find(
      (reviewer) => reviewerId === getId(reviewer),
    ),
  },
};
